export const File = [
  {
    type: 'menu',
    text: 'Yeni',
    position: {
      left: 'calc(100% - 4px)',
      top: '-3px',
    },
    items: [
      {
        type: 'item',
        text: 'Pencere',
        hotkey: 'Ctrl+N',
      },
      { type: 'separator' },
      {
        type: 'item',
        text: 'Mesaj',
      },
      {
        type: 'item',
        text: 'Gönder',
      },
      {
        type: 'item',
        text: 'İletişim',
      },
      {
        type: 'item',
        text: 'İnternet Araması',
      },
    ],
  },
  {
    type: 'item',
    text: 'Aç...',
    hotkey: 'Ctrl+O',
  },
  {
    type: 'item',
    text: 'Düzenle',
    disable: true,
  },
  {
    type: 'item',
    disable: true,
    text: 'Kaydet',
    hotkey: 'Ctrl+S',
  },
  {
    type: 'item',
    text: 'Farklı Kaydet...',
  },
  {
    type: 'separator',
  },
  {
    type: 'item',
    text: 'Sayfa Yapısı...',
  },
  {
    type: 'item',
    text: 'Yazdır...',
    hotkey: 'Ctrl+P',
  },
  {
    type: 'item',
    text: 'Önizleme...',
  },
  {
    type: 'separator',
  },
  {
    type: 'menu',
    text: 'Gönder',
    position: {
      left: 'calc(100% - 4px)',
      top: '-3px',
    },
    items: [
      {
        type: 'item',
        text: 'Sayfayı E-posta ile Gönder…',
      },
      {
        type: 'item',
        text: 'Bağlantıyı E-posta ile Gönder…',
      },
      {
        type: 'item',
        text: 'Masaüstüne Kısayol',
      },
    ],
  },
  {
    type: 'item',
    text: 'İçeri ve Dışarı Aktar...',
  },
  {
    type: 'separator',
  },
  {
    type: 'item',
    text: 'Özellikler',
  },
  {
    type: 'item',
    text: 'Çevrimdışı Çalış',
  },
  {
    type: 'item',
    text: 'Kapat',
  },
];

const Edit = [
  {
    type: 'item',
    disable: true,
    text: 'Kes',
    hotkey: 'Ctrl+X',
  },
  {
    type: 'item',
    disable: true,
    text: 'Kopyala',
    hotkey: 'Ctrl+C',
  },
  {
    type: 'item',
    disable: true,
    text: 'Yapıştır',
    hotkey: 'Ctrl+V',
  },
  {
    type: 'separator',
  },
  {
    type: 'item',
    text: 'Tümünü Seç',
    hotkey: 'Ctrl+A',
  },
  {
    type: 'separator',
  },
  {
    type: 'item',
    text: 'Bul (Bu Sayfada)...',
    hotkey: 'Ctrl+F',
  },
];

const View = [
  {
    type: 'menu',
    position: {
      left: 'calc(100% - 4px)',
      top: '-3px',
    },
    text: 'Araç Çubukları',
    items: [
      {
        type: 'item',
        symbol: 'check',
        text: 'Standart Düğmeler',
      },
      {
        type: 'item',
        symbol: 'check',
        text: 'Adres Çubuğu',
      },
      {
        type: 'item',
        symbol: 'check',
        text: 'Bağlantılar',
      },
      {
        type: 'separator',
      },
      {
        type: 'item',
        symbol: 'check',
        text: 'Araç Çubuklarını Kilitle',
      },
      {
        type: 'item',
        text: 'Özelleştir...',
      },
    ],
  },
  {
    type: 'item',
    symbol: 'check',
    text: 'Durum Çubuğu',
  },
  {
    type: 'menu',
    position: {
      left: 'calc(100% - 4px)',
      top: '-3px',
    },
    text: 'Gezgin Çubuğu',
    items: [
      {
        type: 'item',
        text: 'Ara',
        hotkey: 'Ctrl+E',
      },
      {
        type: 'item',
        text: 'Favoriler',
        hotkey: 'Ctrl+I',
      },
      {
        type: 'item',
        text: 'Geçmiş',
        hotkey: 'Ctrl+H',
      },
      {
        type: 'item',
        text: 'Dosyalar',
      },
      {
        type: 'separator',
      },
      {
        type: 'item',
        text: 'Günün İpucu',
      },
    ],
  },
  {
    type: 'separator',
  },
  {
    type: 'menu',
    position: {
      left: 'calc(100% - 4px)',
      top: '-3px',
    },
    text: 'Git',
    items: [
      {
        type: 'item',
        disable: true,
        text: 'Geri',
        hotkey: 'Alt+Left Arrow',
      },
      {
        type: 'item',
        disable: true,
        text: 'İleri',
        hotkey: 'Alt+Right Arrow',
      },
      {
        type: 'separator',
      },
      {
        type: 'item',
        text: 'Ana Sayfa',
        hotkey: 'Alt+Home',
      },
      {
        type: 'separator',
      },
      {
        type: 'item',
        text: 'Sunucu bulunamıyor',
        symbol: 'check',
      },
    ],
  },
  {
    type: 'item',
    text: 'Durdur',
    hotkey: 'Esc',
  },
  {
    type: 'item',
    text: 'Yenile',
    hotkey: 'F5',
  },
  {
    type: 'separator',
  },
  {
    type: 'menu',
    position: {
      left: 'calc(100% - 4px)',
      top: '-3px',
    },
    text: 'Metin Boyutu',
    items: [
      {
        type: 'item',
        text: 'En Büyük',
      },
      {
        type: 'item',
        text: 'Daha Büyük',
      },
      {
        type: 'item',
        text: 'Orta',
        symbol: 'circle',
      },
      {
        type: 'item',
        text: 'Daha Küçük',
      },
      {
        type: 'item',
        text: 'En Küçük',
      },
    ],
  },
  {
    type: 'menu',
    position: {
      left: 'calc(100% - 4px)',
      top: '-3px',
    },
    text: 'Kodlama',
    items: [
      {
        type: 'item',
        text: 'Otomatik Seçim',
      },
      {
        type: 'separator',
      },
      {
        type: 'item',
        text: 'Batı Avrupa (Windows)',
        symbol: 'circle',
      },
      {
        type: 'menu',
        position: {
          left: 'calc(100% - 4px)',
          top: '-3px',
        },
        text: 'Daha fazla',
        items: [
          {
            type: 'item',
            text: 'Arabic(ASMO 708)',
          },
          {
            type: 'separator',
          },
          {
            type: 'item',
            text: 'Geleneksel Çince',
          },
        ],
      },
    ],
  },
  {
    type: 'separator',
  },
  {
    type: 'item',
    text: 'Kaynak',
  },
  {
    type: 'item',
    disable: true,
    text: 'Gizlilik Raporu...',
  },
  {
    type: 'item',
    text: 'Tam Ekran',
    hotkey: 'F11',
  },
];
const Favorites = [
  {
    type: 'item',
    text: 'Sık Kullanılanlara Ekle...',
  },
  {
    type: 'item',
    text: 'Sık Kullanılanları Düzenle...',
  },
  {
    type: 'separator',
  },
  {
    type: 'menu',
    symbol: 'folder',
    position: {
      left: 'calc(100% - 4px)',
      top: '-3px',
    },
    text: 'Bağlantılar',
    items: [
      {
        type: 'item',
        text: 'Bağlantıları Özelleştir',
        symbol: 'ie-paper',
      },
      {
        type: 'item',
        text: 'Hotmail',
        symbol: 'ie-paper',
      },
      {
        type: 'item',
        text: 'Windows',
        symbol: 'ie-paper',
      },
      {
        type: 'item',
        text: 'Windows Marketplace',
        symbol: 'ie-book',
      },
      {
        type: 'item',
        text: 'Windows Medya',
        symbol: 'ie-paper',
      },
    ],
  },
  {
    type: 'item',
    text: 'MSN.com',
    symbol: 'ie-paper',
  },
  {
    type: 'item',
    text: 'Radyo İstasyonu Rehberi',
    symbol: 'ie-paper',
  },
];
const Tools = [
  {
    type: 'menu',
    position: {
      left: 'calc(100% - 4px)',
      top: '-3px',
    },
    text: 'Posta ve Haber',
    items: [
      {
        type: 'item',
        text: 'Postaları Oku',
      },

      {
        type: 'item',
        text: 'Yeni İleti...',
      },
      {
        type: 'item',
        text: 'Bağlantı Gönder...',
      },
      {
        type: 'item',
        text: 'Sayfa Gönder...',
      },
      {
        type: 'separator',
      },
      {
        type: 'item',
        text: 'Haberleri Oku',
      },
    ],
  },
  {
    type: 'menu',
    position: {
      left: 'calc(100% - 4px)',
      top: '-3px',
    },
    text: 'Açılır Pencere Engelleyicisi',
    items: [
      {
        type: 'item',
        text: 'Açılır Pencere Engelleyicisini Kapat',
      },

      {
        type: 'item',
        text: 'Açılır Pencere Engelleyici Ayarları...',
      },
    ],
  },
  {
    type: 'item',
    text: 'Eklentileri Yönet...',
  },
  {
    type: 'item',
    text: 'Eşitle...',
  },
  {
    type: 'item',
    text: 'Windows Güncellemesi',
  },
  {
    type: 'separator',
  },
  {
    type: 'item',
    text: 'Windows Messenger',
  },
  {
    type: 'item',
    text: 'Bağlantı Sorunlarını Tanıla...',
  },
  {
    type: 'separator',
  },
  {
    type: 'item',
    text: 'İnternet Seçenekleri...',
  },
];
const Help = [
  {
    type: 'item',
    text: 'İçindekiler ve Dizin',
  },
  {
    type: 'item',
    text: 'Günün İpucu',
  },
  {
    type: 'item',
    text: 'Netscape Kullanıcıları İçin',
  },
  {
    type: 'item',
    text: 'Çevrimiçi Destek',
  },
  {
    type: 'item',
    text: 'Geri Bildirim Gönder',
  },
  {
    type: 'separator',
  },
  {
    type: 'item',
    text: 'Internet Explorer Hakkında',
  },
];
export default { File, Edit, View, Favorites, Tools, Help };
